export interface Terms {
  title?: string;
  content?: string[];
  list?: string[];
  section?: TermsSection[];
}

export interface TermsSection {
  title: string;
  subsection?: TermsSubsection[];
}

export interface TermsSubsection {
  title: string;
  content?: string[];
}

export const termsAndConditions: Terms[] = [
  {
    content: [
      "Selamat datang di BisnisLink.id! Dengan menggunakan layanan kami, Anda menyetujui syarat dan ketentuan berikut. Harap baca dengan saksama sebelum menggunakan platform ini.",
    ],
  },
  {
    title: "Definisi",
    list: [
      "BisnisLink.id: Bisnislink adalah platform yang menghubungkan UMKM (Usaha Mikro Kecil dan Menengah) sebagai Supplier dengan Reseller yang siap membantu memasarkan dan menjualkan produk-produk dari Supplier secara online",
      "Supplier (UKM): Pihak yang menawarkan produk di BisnisLink.id.",
      "Reseller: Pihak yang menjual kembali produk dari UKM/Supplier yang tersedia di platform.",
      "Pembeli: Pihak yang melakukan pembelian produk melalui platform.            ",
    ],
  },
  {
    title: "Ketentuan Umum",
    list: [
      "Dengan mendaftar dan menggunakan BisnisLink.id, Anda menyetujui seluruh Syarat & Ketentuan ini.",
      "Kami berhak mengubah kebijakan sewaktu-waktu dan akan memberitahukan melalui platform atau email terdaftar.",
      "Dilarang menggunakan layanan kami untuk aktivitas ilegal atau melanggar hukum yang berlaku.",
    ],
  },
  {
    title: "Akun dan Keamanan",
    list: [
      "Setiap pengguna wajib membuat akun dengan informasi yang valid.",
      "Anda bertanggung jawab atas keamanan akun dan kata sandi Anda.",
      "Jika terjadi aktivitas mencurigakan, segera laporkan ke support@bisnislink.id",
    ],
  },
  {
    title: "Ketentuan Supplier (UKM)",
    list: [
      "Produk yang dijual harus sesuai dengan peraturan dan tidak melanggar hak cipta atau merek dagang pihak lain.",
      "Supplier/UKM bertanggung jawab atas ketersediaan produk, kualitas, dan pengiriman sesuai deskripsi yang diberikan.",
      "Harga dan stok harus diperbarui secara berkala untuk menghindari kesalahan pesanan.",
    ],
  },
  {
    title: "Ketentuan Reseller",
    list: [
      "Reseller dapat menjual kembali produk UKM dengan harga yang ditentukan oleh Supplier.",
      "Reseller harus memiliki akun resmi di BisnisLink.id dan terdaftar sebagai reseller aktif.",
      "Penjualan harus dilakukan melalui sistem yang terintegrasi di BisnisLink.id agar tercatat dalam perhitungan bonus.",
      "Bonus yang didapatkan Reseller akan dihitung berdasarkan transaksi yang telah berhasil diselesaikan, bukan pemesanan yang belum dibayar atau dibatalkan",
      "Dilarang melakukan klaim sebagai pemilik produk tanpa izin dari UKM.",
    ],
  },
  {
    title: "Ketentuan Pembeli",
    list: [
      "Pembeli wajib membaca deskripsi produk dengan teliti sebelum melakukan transaksi.",
      "Setelah pembayaran dikonfirmasi, pesanan tidak dapat dibatalkan kecuali ada kesalahan dari pihak penjual.",
      "Pembayaran dilakukan melalui metode yang tersedia di BisnisLink.id",
      "Jika pembeli melakukan pembayaran langsung kepada reseller di luar sistem BisnisLink.id, maka tanggung jawab transaksi sepenuhnya ada pada kedua belah pihak.",
    ],
  },
  {
    title: "Pembayaran dan Komisi",
    list: [
      "Semua transaksi dilakukan melalui metode pembayaran yang tersedia di BisnisLink.id.",
      "Komisi reseller otomatis dihitung berdasarkan persentase yang telah disepakati.",
      "Dana hasil penjualan akan ditransfer ke rekening UKM atau reseller sesuai jadwal pencairan.",
    ],
  },
  {
    title: "Pengiriman dan Pengembalian Barang",
    list: [
      "Semua pengiriman dilakukan langsung oleh supplier/produsen, sehingga BisnisLink.id tidak bertanggung jawab atas kerusakan, keterlambatan, atau kehilangan barang yang terjadi selama pengiriman.",
      "Pengiriman dilakukan oleh jasa ekspedisi yang bekerja sama dengan BisnisLink.id.",
      "Jika terjadi keterlambatan atau kendala dalam pengiriman, pembeli dan penjual diharapkan menyelesaikan secara musyawarah.Pembeli dapat menghubungi supplier melalui fitur chat yang tersedia di platform.",
      "Komplain terkait produk harus dilakukan dalam waktu 3x24 jam setelah barang diterima.",
    ],
  },
  {
    title: "Proses Pengajuan Pengembalian dan Komplain",
    section: [
      {
        title: "Pengajuan dalam 3x24 jam",
        subsection: [
          {
            title:
              "Pembeli harus mengajukan komplain maksimal 3x24 jam setelah barang diterima, dengan menyertakan:",
            content: [
              "Foto/video produk saat diterima.",
              "Bukti pesanan dan invoice dari BisnisLink.id.",
              "Deskripsi keluhan secara jelas.",
            ],
          },
          {
            title: "Jika melewati batas waktu, pengajuan tidak akan diterima.",
          },
        ],
      },
      {
        title: "Verifikasi oleh Supplier/Produsen",
        subsection: [
          {
            title:
              "Supplier/Produsen memiliki hak untuk memverifikasi keluhan dan menentukan apakah pengembalian dapat diproses.",
          },
          {
            title: "Jika komplain disetujui, supplier akan menawarkan",
            content: [
              "Penggantian produk baru",
              "Pengembalian dana (refund) sesuai kesepakatan",
            ],
          },
        ],
      },
      {
        title: "Pengiriman Kembali Produk",
        subsection: [
          {
            title:
              "Jika produk perlu dikembalikan, pembeli wajib mengirimkan ke alamat supplier dalam kondisi yang sama seperti saat diterima.",
          },
          {
            title:
              "Biaya pengiriman pengembalian ditanggung oleh pihak yang bersalah (supplier atau pembeli, sesuai hasil verifikasi).",
          },
        ],
      },
    ],
  },
  {
    title: "Hak dan Kewajiban",
    list: [
      "Kami berhak menonaktifkan akun yang terbukti melanggar aturan tanpa pemberitahuan terlebih dahulu.",
      "BisnisLink.id tidak bertanggung jawab atas kesalahan transaksi yang dilakukan di luar platform resmi kami.",
      "Kami berhak mengubah sistem komisi, metode pembayaran, dan kebijakan lain sesuai perkembangan bisnis.",
    ],
  },
  {
    title: "Penyelesaian Sengketa",
    list: [
      "Jika terjadi ketidaksepakatan antara pembeli dan supplier, BisnisLink.id dapat menjadi perantara, tetapi tidak bertanggung jawab atas keputusan akhir.",
      "Penyelesaian dilakukan secara musyawarah antara kedua belah pihak. Jika tidak ditemukan kesepakatan, pembeli dapat menyelesaikannya melalui jalur hukum yang berlaku.",
    ],
  },
  {
    content: [
      "Dengan menggunakan BisnisLink.id, Anda menyatakan telah membaca, memahami, dan menyetujui seluruh Syarat & Ketentuan ini.",
    ],
  },
];
